import { render, staticRenderFns } from "./dsBasketCondition.vue?vue&type=template&id=267146b6&scoped=true"
import script from "./dsBasketCondition.vue?vue&type=script&lang=js"
export * from "./dsBasketCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267146b6",
  null
  
)

export default component.exports